<template>
  <div class="main-container bg-grey-lightest">
    <div class="main-content-wrap">
      <div class="main-content-pannel">
        <div
          class="option-wrap bg-grey-lightest grey-bg-option no-border"
          style="height: 100px"
        >
          <div class="options">
            <div class="breadcrumb">
              <a href="javascript:void(0);" class="cursor-default"></a>
            </div>
            <div class="content-title-wrap p-t-0">
              <div class="main-content-title">
                {{ company ? company.name : "" }}'s Overview
              </div>
            </div>
          </div>
        </div>
        <div class="main-bg p-0 m-t-0 m-b-l">
          <div class="pannel-1">
            <div class="flex">
              <div class="flex-3">
                <div class="dashboard-statistics flex">
                  <div>
                    <h6>Billing Amount</h6>
                    <p>{{ billingAmount | currencyFilter("$", 2) }}</p>
                  </div>
                  <div>
                    <h6>Hours Total</h6>
                    <p class="font-color-lighter">{{ monthHours }}</p>
                  </div>
                </div>
                <div class="dashboard-calendar">
                  <Calendar
                    style="width: 100%"
                    :index="'clientDashboard'"
                    :data="calendarData"
                    :key="calendarKey"
                    @dateChange="updateCalendarBoard"
                  ></Calendar>
                </div>
              </div>
              <div class="flex-2" style="max-width: 416px">
                <div class="dashboard-project" v-if="company">
                  <div>
                    <h3 class="dashboard-project-title">Projects</h3>
                    <ProjectItem
                      v-for="(item, index) in projectRoles || []"
                      :key="index"
                      :data="item"
                    />
                  </div>
                  <div>
                    <h3
                      class="dashboard-project-title"
                      style="margin-top: 12px"
                    >
                      Software
                    </h3>
                    <SoftwareItem
                      v-for="(item, index) in company.software || []"
                      :key="index"
                      :data="item"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="main-bg p-0 m-t-0 m-b-0">
          <div class="pannel-1">
            <div class="pannel-1-title p-t-l"><h3>Work log</h3></div>
            <div class="pannel-1-body">
              <ag-grid-vue
                style="width: 100%; height: 300px"
                class="ag-theme-material"
                :gridOptions="gridOptions"
                :columnDefs="columnDefs"
                @column-resized="onColumnResized"
                :rowData="rowData"
              ></ag-grid-vue>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { db } from "@/vendor/firebase";
import EditPannel from "@/components/EditPannel.vue";
import GridConsultant from "@/components/client/clientDashboard/GridConsultant";
import GridCheckin from "@/components/client/clientDashboard/GridCheckin";
import * as utils from "@/utils/utils";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/css/ag-grid.scss";
import PanelDashboard from "@/components/client/clientDashboard/PanelDashboard.vue";
import Calendar from "@/components/public/Calendar.vue";
import SoftwareItem from "@/components/client/clientDashboard/SoftwareItem.vue";
import ProjectItem from "@/components/client/clientDashboard/ProjectItem.vue";

export default {
  props: ["editOpenTitle"],
  data() {
    return {
      queryId: null,
      company: null,
      jobs: null,
      consultants: null,
      projects: null,

      emailToConsultant: null,
      monthlyConsultants: null,

      rowData: [],
      gridOptions: {},
      columnDefs: null,

      calendarData: {},
      calendarKey: 0,
      nextInvoiceDate: moment().endOf("month").format("MM/DD/YYYY"),
      monthHours: 0,
      billingAmount: 0,

      editOpen: false,
      selectedConsultant: null,
      selectedConsultantIndex: -1,

      roles: [],

      softwareSubmitLoading: false,
    };
  },
  computed: {
    projectRoles() {
      const rv = [];
      (this.projects || [])
        .filter((item) => item.phase === "Operational")
        .forEach((item) => {
          const roles = item.roles;
          const selected_consultants = item.selected_consultants;
          if (roles) {
            roles.forEach((roleItem) => {
              let price = 0;
              if (
                !isNaN(roleItem.hours_per_week) &&
                !isNaN(roleItem.rate_to_client)
              ) {
                price =
                  Number(roleItem.hours_per_week) *
                  Number(roleItem.rate_to_client) *
                  4;
              }
              roleItem.price = price;
              const consultants = (
                (selected_consultants || []).find(
                  (item) => item.role_id === roleItem.id
                )?.consultants || []
              )
                .filter((item) => item.status === "Current Contractor")
                .map((item) => {
                  return this.consultants.find(
                    (consultantItem) => consultantItem.id === item.id
                  );
                });
              roleItem.consultants = consultants;
              rv.push(roleItem);
            });
          }
        });
      return rv;
    },
  },
  watch: {
    editOpenTitle: function (val) {
      this.editOpen = val;
    },
    jobs: function () {
      this.updateWorkLogAndCalendar();
    },
    consultants: function () {
      this.updateEmailToConsultant();
      this.updateWorkLogAndCalendar();
    },
    projects: function () {
      this.updateRoles();
    },
  },
  components: {
    EditPannel,
    Calendar,
    PanelDashboard,
    AgGridVue,
    GridConsultant,
    GridCheckin,
    SoftwareItem,
    ProjectItem,
  },
  beforeMount() {
    this.queryId = this.$route.query.id;
    this.initColumnDefs();
    this.bindData();
  },
  methods: {
    bindData: function () {
      this.$bind("company", db.collection("companies").doc(this.queryId));
      this.$bind(
        "jobs",
        db.collection("jobs").where("company", "==", this.queryId)
      );
      this.$bind("consultants", db.collection("consultants"));
      this.$bind(
        "projects",
        db.collection("gigs").where("company", "==", this.queryId)
      );
    },
    initColumnDefs: function () {
      this.gridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.columnDefs = [
        {
          headerName: "CONSULTANT",
          field: "consultant",
          cellRendererFramework: "GridConsultant",
        },
        {
          headerName: "Date",
          field: "checkin",
          comparator: utils.dateComparator,
          sort: "desc",
          cellRendererFramework: "GridCheckin",
          sortingOrder: ["desc", "asc"],
        },
        {
          headerName: "Description",
          field: "summary",
          cellClass: "word-wrap",
          flex: 1,
        },
        {
          headerName: "HOURS",
          field: "hours",
          cellClass: ["font-color-green", "text-right"],
        },
      ];
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    updateEmailToConsultant: function () {
      if (this.consultants) {
        const emailToConsultant = {};
        this.consultants.forEach((item) => {
          if (item.email) {
            emailToConsultant[item.email] = item;
          }
        });
        this.emailToConsultant = emailToConsultant;
      }
    },
    updateMonthlyConsultants: function (ts) {
      if (
        this.jobs &&
        this.jobs.length > 0 &&
        this.consultants &&
        this.consultants.length > 0 &&
        this.emailToConsultant
      ) {
        const monthlyConsultants = {};
        const startTimestamp = ts / 1000;
        const endTimestamp =
          moment(ts).tz("America/Los_Angeles").endOf("month").valueOf() / 1000;
        this.jobs.forEach((item) => {
          if (
            item.check_in >= startTimestamp &&
            item.check_in <= endTimestamp &&
            item.consultant &&
            this.emailToConsultant[item.consultant]
          ) {
            const hours = utils.workHours(
              item.check_out - item.check_in,
              item.work_type
            );
            if (monthlyConsultants[item.consultant]) {
              monthlyConsultants[item.consultant].hours += hours;
            } else {
              monthlyConsultants[item.consultant] = {
                id: this.emailToConsultant[item.consultant].id,
                email: this.emailToConsultant[item.consultant].email,
                name: this.emailToConsultant[item.consultant].name,
                photoUrl: this.emailToConsultant[item.consultant].photo_url,
                rate: this.company.rate,
                hours: hours,
              };
            }
          }
        });
        this.monthlyConsultants = monthlyConsultants;
      }
    },
    updateWorkLogAndCalendar: function () {
      if (
        this.jobs &&
        this.jobs.length > 0 &&
        this.consultants &&
        this.consultants.length > 0 &&
        this.emailToConsultant
      ) {
        const rowData = [];
        const calendarData = {};
        this.jobs.forEach((item) => {
          const hours = utils.workHours(
            item.check_out - item.check_in,
            item.work_type
          );
          rowData.push({
            checkin: utils.dateformat(item.check_in, "MM/DD/YYYY HH:mm A"),
            consultant:
              this.emailToConsultant[item.consultant] &&
              this.emailToConsultant[item.consultant].name
                ? this.emailToConsultant[item.consultant].name
                : item.consultant,
            summary: item.summary,
            hours: hours,
          });
          const calendarIndex = utils.dateformat(item.check_in, "YYYYMMDD");
          if (calendarData["i_" + calendarIndex]) {
            calendarData["i_" + calendarIndex] = {
              hours: calendarData["i_" + calendarIndex].hours + hours,
              isHistory: true,
            };
          } else {
            calendarData["i_" + calendarIndex] = {
              hours: hours,
              isHistory: true,
            };
          }
        });
        this.rowData = rowData;
        this.calendarData = calendarData;
        this.calendarKey++;
        this.updateCalendarBoard(
          moment().tz("America/Los_Angeles").startOf("month").valueOf()
        );
        this.updateMonthlyConsultants(
          moment().tz("America/Los_Angeles").startOf("month").valueOf()
        );
      }
    },
    updateCalendarBoard: function (ts) {
      if (
        this.jobs &&
        this.jobs.length > 0 &&
        this.consultants &&
        this.consultants.length > 0 &&
        this.emailToConsultant
      ) {
        const startTimestamp = ts / 1000;
        const endTimestamp =
          moment(ts).tz("America/Los_Angeles").endOf("month").valueOf() / 1000;
        this.nextInvoiceDate = moment(ts)
          .tz("America/Los_Angeles")
          .endOf("month")
          .format("MM/DD/YYYY");
        let monthHours = 0;
        let billingAmount = 0;
        this.jobs.forEach((item) => {
          if (
            item.check_in >= startTimestamp &&
            item.check_in <= endTimestamp
          ) {
            const hours = utils.workHours(
              item.check_out - item.check_in,
              item.work_type
            );
            monthHours += hours;
            const amount = hours * utils.toNumber(this.company.rate);
            billingAmount += amount;
          }
        });
        this.monthHours = monthHours;
        this.billingAmount = billingAmount;
      }
      this.updateMonthlyConsultants(ts);
    },
    // edit pannel: control open which component
    openEditPanel: function (action, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
    },
    closeEditPanel: function () {
      this.editOpen = false;
      this.selectedConsultantIndex = -1;
    },
    selectConsultant: function (item, index) {
      if (this.selectedConsultantIndex == index && this.editOpen) {
        this.closeEditPanel();
      } else {
        this.selectedConsultantIndex = index;
        this.selectedConsultant = item;
        this.openEditPanel(1, true);
      }
    },
    panelButtonClick: function (item, user) {
      return;
      // let appointment = {};
      // Object.assign(appointment, item);
      // appointment.user = user.slackId;
      // appointment.workType = user.workType;
      // appointment.channel_id = this.channel.id;
      // db.collection("appointments")
      //   .add(appointment)
      //   .then(docRef => {
      //     this.closeEditPannel();
      //     this.$toasted.global.toast_success({
      //       message: "Appointment Added success"
      //     });
      //   })
      //   .catch(error => {
      //     this.$toasted.global.toast_error({ message: error });
      //   });
    },
    updateRoles: function () {
      this.roles = [];

      (this.projects || []).forEach((item) => {
        const selectedConsultants = item.selected_consultants;
        const roles = item.roles;
        if (roles) {
          roles.forEach((role) => {
            let consultantDetail = null;
            if (selectedConsultants) {
              const tc = selectedConsultants.find((c) => c.role_id === role.id);
              if (tc) {
                const c = tc.consultants;
                if (c) {
                  c.forEach((citem) => {
                    if (citem.quote) {
                      const cdetail = this.consultants.find(
                        (item) => item.id === citem.id
                      );
                      // consultantDetail = cdetail;
                      // consultantDetail.role_rate_to_client =
                      //   citem.role_rate_to_client;
                    }
                  });
                }
              }
            }
            const amount =
              (role.hours_per_week ? Number(role.hours_per_week) : 0) *
              (role.rate_to_client ? Number(role.rate_to_client) : 0) *
              4;
            this.roles.push({ ...role, consultantDetail, amount });
          });
        }
      });
    },
    addSoftware: function () {
      this.openEditPannel(1, "Software", true);
    },
    openEditPannel: function (action, title, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        this.emitEditPannel(title);
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
      this.emitEditPannel(title);
    },
    closeEditPannel: function () {
      this.editOpen = false;
      this.emitEditPannel();
    },
    emitEditPannel: function (title) {
      const param = {
        title: title,
        editOpen: this.editOpen,
      };
      this.$emit("openEditPannelTitle", param);
    },
  },
};
</script>

<style scoped>
.user-wrapper {
  display: flex;
  align-items: center;
}
</style>
